import styled from "styled-components";

export const Container = styled.div`
  position: relative;

  input {
    padding-right: 2.5em;
  }

  button {
    background: none;
    border: none;
    position: absolute;
    right: 0.8em;
    bottom: 0.45em;
    color: #cedde0;
    font-size: 1.6em;

    :hover {
      cursor: pointer;
    }
  }
`;
